<template>
  <div v-if="loading">
        <br>GodService ...<br><br>
        <br>Loading ... app. version {{ wdm.version }}
        <div v-if="loginStep"><br>Step nummer {{ loginStep }}</div>
        <div><br><br>{{ loginText }}</div>
</div>
  <div v-else>
  <div class="mainApp">
    <div v-if="true"><mainMenu :roles="roles" :currentUser="currentUser" :currentUserName="currentUserName" :authenticated="authenticated" @login="login" @logout="logout"/></div>
    <div v-else class="menuPlaceholder"><img class="logo" src="@/assets/GodEnergi_logo.svg"></div>
    <div class="scrollView" id="scrollView">
      <div class="header"></div>
      <div class="routerView"><router-view/></div>
      <div class="footer"></div>
    </div>
</div>
</div>
</template>

<script>
import mainMenu from './components/mainMenu.vue'
  
export default {
  components : { mainMenu },
  inject:[ 'wdm'],
  data() {
    return {
      loginStep: 0,
      loginText: '',
      loading: true,
      authenticated: false,
      loading: true,
      currentUser : '',
      currentUserName : '',
      currentValue : 'CV',
      currentDate: '',
      boxDates: [],
      accounts: [],
      roles:[],
      onLine: navigator.onLine,
      myMSALObj: undefined,
      msalConfig: {
                  auth: { clientId: process.env.VUE_APP_MSAL_clientId,
                          authority: process.env.VUE_APP_MSAL_authority,
                          redirectUri: process.env.VUE_APP_MSAL_redirectUri, },
                  cache: { cacheLocation: "sessionStorage", 
                           storeAuthStateInCookie: false  }
                    },
      loginRequest:  { scopes: ["profile", "User.Read" ] },
      APItokenRequest: { scopes: [ process.env.VUE_APP_MSAL_APItokenRequest ]  },
      GRAPHtokenRequest: { scopes: ["openid", "profile", "User.Read"]},
    }
  },
  created() {
    this.wdm.system = process.env.VUE_APP_system
    window.document.title = process.env.VUE_APP_title

    console.log(this.wdm.system + ' - ' + String(this.wdm.version))

    if (window.location.hostname == 'godservice-test.wedomobility.com') {
        window.document.title = '(TEST) GodService';  
        this.wdm.system = 'TEST';
      } 
      
      this.myMSALObj = new Msal.UserAgentApplication(this.msalConfig); 
      this.loginStep = 1
      this.myMSALObj.handleRedirectCallback( (error, response) => {
                          console.log("redirectCallback")
                          if (error) {
                            this.loginStep = 2
                            console.log("error")
                            console.log(error)
                          } else {
                            this.loginStep = 3
                            console.log("response")
                            console.log(response)
                          }
                    });
                    
      if (this.myMSALObj.getAccount()) {
        this.loginStep = 4
        console.log('already logged in - renewToken()')
        this.renewToken()
       } else {
        this.loginStep = 5
        console.log('not logged in...')
        this.loading=false
       }
  },
  mounted() {
    
  },
  methods: {
    logout() {
      if (this.authenticated) {
            this.wdm.authenticated = false
            this.authenticated = false
            this.myMSALObj.logout();
          }
      },
    async login(){ 
            this.myMSALObj.loginPopup(this.loginRequest)
                .then(() => {
                    if (this.myMSALObj.getAccount()) {
                      this.renewToken()
                    } else {
                      console.log('no getAccount')
                    }
                    }).catch(error => {
                      console.log('hmm1')
                        console.log(error);
                    });
                },
    async renewToken() {
      this.loginStep = 6
    const req = await this.myMSALObj.acquireTokenSilent(this.APItokenRequest).catch(error => {
                    console.log(error);
                    console.log("silent token acquisition fails. acquiring token using popup");
                    this.loginText = "FEJL - Deaktiver Popupblocker i iOS-Indstillinger, Safari, Blokér Pop-ups"
                    this.loginStep = 7
                    return this.myMSALObj.acquireTokenPopup(this.APItokenRequest)
                        .then(tokenResponse => {
                            return tokenResponse;
                        }).catch(error => {
                          this.loginStep = 8
                            console.log(error);
                        });
                });
      this.loginStep = 9
      if(req) { 
          this.loginText = "got TokenSilent..." 
          this.loginStep = 9
          this.currentUser= this.myMSALObj.getAccount().userName
          this.loginStep = 91
          this.currentUserName = this.myMSALObj.getAccount().name
          this.loginStep = 92
          this.wdm.authenticated=true
          this.loginStep = 93
          this.authenticated=true
          this.loginStep = 94
          this.wdm.token = req.accessToken
          this.loginStep = 95
          await this.getRoles()
          if ('DEVTESTLocal'.includes(this.wdm.system)) {
                console.log('--------- API TOKEN -----------')
                console.log(this.wdm.token)
                console.log('--------- API TOKEN -----------') 
            }
      }
      this.loading=false
      if(this.authenticated) {
        await this.getUserImage()
        this.loginStep = 10
        console.log('Authenticated')
      } else {
        this.loginStep = 11
        console.log('Endnu ikke authenticated')

      }
      
      
      },  
    
    async getRoles() {
      this.loginStep = 901
      const res = await this.wdmFetch("getstatus", "GET", null)
      if (res.ok) {
        this.loginStep = 902
        const result = await res.json()
        if (result.roles) {
            this.wdm.roles = result.roles
            this.roles = result.roles
            this.getCustomerAbbreviations()
        } else {
          this.loginStep = 903
            this.roles = ['noAccess']
            this.wdm.roles = ['noAccess']
        }
      } else {
        this.fetchError(res)
      }

    },
    async getUserImage() {
      const graphReq = await this.myMSALObj.acquireTokenSilent(this.GRAPHtokenRequest)
      this.wdm.graphtoken = graphReq.accessToken
      const headers = new Headers();
      const bearer = `Bearer ${graphReq.accessToken}`;
      headers.append("Authorization", bearer);
      const options = { 
          method: "GET",
          headers: headers };
      const res = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", options)
      if (res.ok) {
          const image = await res.blob()
          const imageURL = URL.createObjectURL(image)
          let photo = document.getElementById('profilePhoto')
          if (photo) photo.src = imageURL
          photo = document.getElementById('profilePhotoMenu')
          if (photo) photo.src = imageURL
      } else { 
        console.log('ikke noget photo eller noget gik galt...')
      } 
    },

    async getCustomerCoordinates(){
      const res = await this.wdmFetch('get/coordinate','GET', null)
            if (res.ok) {
                const result = await res.json()
                //console.log(result)
                result.value.forEach(async (coordinate) =>  {
                     this.wdm.customerCoordinates[coordinate.id] = [ coordinate.lon, coordinate.lat ]
                })
                //console.log(this.wdm.customerCoordinates)
            } else {
                console.log(res.status)
                this.fetchError(res)
            }
        
    },

    async getCustomerAbbreviations() {
            //console.log(this.wdm.token.split('P')[0])
            const res = await this.wdmFetch('get/customerAbbreviation','GET', null)
            if (res.ok) {
                const result = await res.json()
                //console.log(result)
                result.value.forEach(async (oneCustomer) =>  {
                     this.wdm.customerAbbreviations[oneCustomer.RowKey] = { 'Color':oneCustomer.Color, 'callSign':oneCustomer.callSign } 
                })
                this.getCustomerCoordinates()
            } else {
                console.log(res.status)
                this.fetchError(res)
            }
        
        },
  }
}
</script>

<style>

:root {
--godenergi-green    :  #81B532;
--godenergi-lightgreen : #C8D423;
--godenergi-orange:#EA852B;
--godenergi-lightblue:#2AC2FD;
--godenergi-darkblue:#013D54;
--godenergi-lightred:#FC5984;
--godenergi-darkred:#850F2E;

}

#app {
  font-family: "Poppins", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}

.logo { 
  height: 70px;
  margin-top: 20px;
  position: absolute;
  left: 50px;

}
.routerView {   
              border: 0px solid black;
              }

.maxedRouterView {
                padding-left: 10px;
                padding-right: 10px;
                margin-top: 10px;
                max-width: 1326px; 
}

h1 {
    font-size: 60px;
    font-weight: 700;
    line-height: 70px;
    letter-spacing: -0.79px;
    
}
.align-left {
  text-align: left;
}

.left-padding {
  padding-left: 10px;  
}

.menuPlaceholder {
  height: 110px;
  background-color: var(--godenergi-green);
}

.scrollView {
  height: calc(100vh - 110px);
  overflow-y: auto ;

}

.white {
  color: white;
}

table {
    border-collapse: separate;
    text-indent: initial;
    border-spacing: 0px;
    width: 100%;
    border: 1px solid;
}

thead {
    background-color : var(--godenergi-green );
    color: white;
    height: 80px;
}

tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    height: 80px;

}

tbody tr:nth-child(odd) {
    background-color: var(--godenergi-lightgreen );
}

@media screen and (max-width:1000px) {

  h1 {
    font-size: 25px;
  
  }

}
</style>
